import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/university/ab-tests/$testId')({

}).lazy(() => import('./$testId.lazy').then((d) => d.Route));
